import { SlideGallery } from "@/features/work/SlideGallery";

const slides = [
  {
    src: "/images/i4j/slide-01.jpg",
    caption: "Title",
    alt: "Title slide: i4j Ecological View of the Ecosystem. i4j summit, 29 January 2016. Dr David Nordfors, i4j. Analysis by Dr Jay van Zyl, i4j Analytics Partner, @jayvanzyl.",
  },
  {
    src: "/images/i4j/slide-02.jpg",
    caption: "Categories and knowledge",
    alt: "Categories and knowledge. A green network with the note that marketplaces, education, career management, and employment are highly central focus areas.",
  },
  {
    src: "/images/i4j/slide-03.jpg",
    caption: "Category network",
    alt: "Dense category network labeled i4j - categories. Green edges, yellow hubs of different sizes, and an i4j Ecosystem badge.",
  },
  {
    src: "/images/i4j/slide-04.jpg",
    caption: "Labeled categories",
    alt: "The same category network with labels: Consulting, Staffing Firms, Information Technology, Human Resources, Software, SaaS, Recruiting, Career Management, Mobile, Networking, Search, Employment, Marketplaces, Social Media, Education, Curated Web, and Advertising.",
  },
  {
    src: "/images/i4j/slide-05.jpg",
    caption: "Central categories",
    alt: "Category network with callouts on Software, Career Management, Staffing Firms, Recruiting, Mobile, Employment, Marketplaces, and Advertising.",
  },
  {
    src: "/images/i4j/slide-06.jpg",
    caption: "Organization and CEO networks",
    alt: "Section slide: Organization x CEO Networks. The business networked central group as a CEO-investor group.",
  },
  {
    src: "/images/i4j/slide-07.jpg",
    caption: "Organization clusters",
    alt: "Sparse organization network labeled i4j all. Green hubs linked to smaller white nodes, in several disconnected clusters.",
  },
  {
    src: "/images/i4j/slide-08.jpg",
    caption: "Named organizations",
    alt: "Organization network with callouts: Wepay, Simply Hired, Eventbrite, Facebook, Zynga, Kickstarter, Readyforce, Thumbtack, Humanoid, Google, 99designs, Uber, Jobs, and Crowd flower.",
  },
  {
    src: "/images/i4j/slide-09.jpg",
    caption: "Investor and organization",
    alt: "Section slide: Investor x Organization. Boundary spanner: the role of linking the organization's internal networks with external sources of information.",
  },
  {
    src: "/images/i4j/slide-10.jpg",
    caption: "Investor graph",
    alt: "Investor and organization graph labeled i4j all-multi. Red circular hubs connected to green square nodes.",
  },
  {
    src: "/images/i4j/slide-11.jpg",
    caption: "Investor components",
    alt: "A filtered view of the investor graph: a few small components, each a red hub with green square neighbors.",
  },
  {
    src: "/images/i4j/slide-12.jpg",
    caption: "Named investors",
    alt: "Investor graph with callouts on Benchmark, Kleiner Perkins, Sequoia Capital, and Northwest Venture.",
  },
  {
    src: "/images/i4j/slide-13.jpg",
    caption: "Investor graph, closer",
    alt: "A closer frame of the investor graph, still calling out Benchmark, Kleiner Perkins, Sequoia Capital, and Northwest Venture.",
  },
  {
    src: "/images/i4j/slide-14.jpg",
    caption: "Benchmark and Kleiner Perkins",
    alt: "Investor graph with firm cards. Benchmark: 441 investments in 237 companies, 24 IPOs and 81 acquisitions, founders Kevin Harvey and Bob Kagle, San Francisco, $1.25B raised, early-stage venture in social, mobile, local, and cloud. Kleiner Perkins: 746 investments in 420 companies, 36 IPOs and 81 acquisitions, founders Eugene Kleiner, Tom Perkins, Frank Caufield, and Brook Byers, Menlo Park, $1.38B raised.",
  },
  {
    src: "/images/i4j/slide-15.jpg",
    caption: "Organization and person",
    alt: "Section slide: Organization x Person. Boundary spanner: the role of linking the organization's internal networks with external sources of information.",
  },
  {
    src: "/images/i4j/slide-16.jpg",
    caption: "Connected world",
    alt: "Connected world. A dense circular organization-and-person network labeled i4j all-multi, with red and green nodes and a tight red core.",
  },
  {
    src: "/images/i4j/slide-17.jpg",
    caption: "Roles",
    alt: "Organization and person graph with role callouts: Partner, Founder, and Software Engineer.",
  },
  {
    src: "/images/i4j/slide-18.jpg",
    caption: "Organization and location",
    alt: "Section slide: Organization x Location, over a green network.",
  },
  {
    src: "/images/i4j/slide-19.jpg",
    caption: "Location clusters",
    alt: "Location network labeled i4j all-multi. Orange hubs with green spokes, plus smaller orange and green clusters.",
  },
  {
    src: "/images/i4j/slide-20.jpg",
    caption: "San Francisco and Mountain View",
    alt: "Location network with San Francisco and Mountain View called out as the large orange hubs, and smaller nodes for other cities.",
  },
  {
    src: "/images/i4j/slide-21.jpg",
    caption: "Singapore, New York, London, Istanbul",
    alt: "Location network with callouts on Singapore, New York, London, and Istanbul. New York is the large orange hub.",
  },
  {
    src: "/images/i4j/slide-22.jpg",
    caption: "Amsterdam, Palo Alto, San Jose, Menlo Park",
    alt: "Location network with callouts on Amsterdam, Palo Alto, San Jose, and Menlo Park.",
  },
  {
    src: "/images/i4j/slide-23.jpg",
    caption: "Paris, San Mateo, Boston, Los Angeles",
    alt: "Location network with callouts on Paris, San Mateo, Boston, and Los Angeles.",
  },
].map((slide) => ({ ...slide, width: 720, height: 540 }));

export function I4jGallery() {
  return <SlideGallery slides={slides} />;
}
